// 准备state--用于存储数据
const state = {
  id: 0, // 用户主键ID默认0
  userName: '', //用户名默认空值
  userType: 20, // 用户类型默认普通用户
  logged: false // 用户是否登录，默认未登录
}
// actions异步请求处理
const actions = {}
// mutations主要用来操作(state)
const mutations = {
  storeUserInfo (state, userInfo) { // 布尔值 true
    state.id = userInfo.id
    state.userName = userInfo.userName
    state.userType = userInfo.userType
    state.logged = userInfo.logged
  },
}

export default {
  state,
  actions,
  mutations
}
